// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"440":"1f353505","551":"2a37cce4","815":"cb0b7040"}[chunkId] + ".chunk.js";
};